const cards = [
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20sci-fi%20movie%20poster%20style%20image%20with%20a%20giant%20planet%20and%20spaceship%20silhouette%20against%20a%20deep%20space%20background%2C%20dramatic%20lighting%20with%20warm%20golden%20and%20deep%20blue%20contrast%2C%20epic%20cinematic%20composition%2C%20no%20text%2C%20clean%20movie%20poster%20aesthetic&width=800&height=1120&seq=card-movie-01&orientation=portrait',
    title: '流浪地球3',
    tag: '科幻巨制',
    rating: '9.3',
    info: '2026 / 科幻 / 2h 38min',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20fantasy%20movie%20poster%20style%20image%20with%20ancient%20Chinese%20mythological%20warriors%20in%20epic%20battle%20formation%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20epic%20scale%20composition%2C%20no%20text%2C%20clean%20movie%20poster%20aesthetic&width=800&height=1120&seq=card-movie-02&orientation=portrait',
    title: '封神第二部',
    tag: '神话史诗',
    rating: '8.9',
    info: '2026 / 奇幻 / 2h 52min',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20historical%20drama%20movie%20poster%20style%20image%20with%20ancient%20Chinese%20palace%20interior%20and%20a%20lone%20figure%20in%20scholar%20robes%2C%20warm%20amber%20lantern%20lighting%2C%20atmospheric%20composition%2C%20no%20text%2C%20clean%20movie%20poster%20aesthetic&width=800&height=1120&seq=card-movie-03&orientation=portrait',
    title: '庆余年3',
    tag: '古装权谋',
    rating: '9.1',
    info: '2026 / 古装 / 45集',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20thriller%20movie%20poster%20style%20image%20with%20a%20mysterious%20figure%20in%20a%20dark%20alley%20under%20neon%20city%20lights%2C%20rain-slicked%20streets%2C%20dramatic%20noir%20lighting%20with%20deep%20shadows%2C%20no%20text%2C%20clean%20movie%20poster%20aesthetic&width=800&height=1120&seq=card-movie-04&orientation=portrait',
    title: '大奉打更人',
    tag: '悬疑探案',
    rating: '8.7',
    info: '2026 / 悬疑 / 40集',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20animated%20movie%20poster%20style%20image%20with%20a%20mythical%20Chinese%20dragon%20soaring%20through%20colorful%20clouds%20above%20ancient%20temples%2C%20vibrant%20warm%20colors%2C%20dynamic%20composition%2C%20no%20text%2C%20clean%20animation%20poster%20aesthetic&width=800&height=1120&seq=card-movie-05&orientation=portrait',
    title: '哪吒之魔童闹海',
    tag: '国产动画',
    rating: '9.5',
    info: '2026 / 动画 / 1h 56min',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            编辑严选
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            编辑团队精心挑选的本月最值得观看的影视佳作
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-5">
          {cards.map((card) => (
            <article key={card.title} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden mb-3 aspect-[2/3] bg-background-200">
                <img
                  src={card.img}
                  alt={`6080新视觉影院 - ${card.title}`}
                  title={`${card.title} - 6080新视觉影院高清电影`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute top-2 left-2">
                  <span className="inline-block px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    {card.rating}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="inline-block px-2 py-0.5 rounded-md bg-background-50/20 backdrop-blur-sm text-background-50 text-xs whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors">
                {card.title}
              </h3>
              <p className="text-xs text-foreground-400 mt-1">{card.info}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}